import { Dispatch, ActionCreator } from "redux";
import { ThunkAction } from "redux-thunk";

import { configUrl } from "../constants/Config";
import { ApplicationState } from "../redux/ApplicationState";
import toastType from "../utils/SnackbarProvider";
import { MyAccountModel } from "../models/MyAccount";
import {
  DeactivateNotification,
  GetAdminSelectedUserByEmail,
  GetPortalUpdate,
  PostAccessAdminList,
  PostAddPortalUpdate,
  PostAddUser,
  PostAdminUserList,
  PostNotification,
  PostNotificationList,
  PutAgencyAccessList,
  PutNotificationUpdate,
} from "../services/User";
import {
  AddPortalUpdateActionDispatchTypes,
  AddUserActionDispatchTypes,
  GetPortalUpdateActionDispatchTypes,
} from "../constants/Admin";
import {
  GetPortalUpdateDispatchTypes,
  PostAddPortalUpdateDispatchTypes,
  PostAddUserDispatchTypes,
} from "../models/dispatchTypes/Admin";
import { AccessAdminActionTypes, NotificationActionTypes, NotificationDeactivateDispatchTypes, NotificationUpdateDispatchTypes, UpdateAgencyAccessActionTypes, UserDetailsActionTypes, UserDetailsInAdminActionTypes } from "../models/dispatchTypes/User";
import { UserListPayload, PortalUpdateData, AdminAccessListPayload, UpdateAgencyAccessPayload } from "../models/User";
import { UserListActionDispatchTypes, UserDetailsInAdminActionDispatchTypes, AccessAdminListActionDispatchTypes, UpdateAgencyAccessListActionDispatchTypes, NotificationActionDispatchTypes, NotificationListActionDispatchTypes, NotificationUpdateActionDispatchTypes, NotificationDeactivateActionDispatchTypes } from "../constants/User";
import { MessageType, ResponseMessages } from "../constants/ResponseMessage";
import { NotificationListDispatchTypes } from "../models/dispatchTypes/Master";
import { DeactivateNotificationPayload } from "../routes/HeaderMenu/components/Notification";

export const postCreateUser: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    PostAddUserDispatchTypes
  >
> = (payload: MyAccountModel) => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: AddUserActionDispatchTypes.POST_ADD_USER_INVOKE,
    });
    const response = await PostAddUser(configUrl, payload);
    if (response && response.status) {
      switch (response.status) {
        case 422:
        case 400:
        case 500:
        case 404:
          dispatch({
            error: response.data,
            type: AddUserActionDispatchTypes.POST_ADD_USER_ERROR,
          });
          typeof response.data === "string" && toastType.error(response.data);
          break;
        case 200:
        case 201:
          toastType.success(ResponseMessages(MessageType.USER_DETAILS_ADDED))
          dispatch({
            response: response.data,
            type: AddUserActionDispatchTypes.POST_ADD_USER_SUCCESS,
          });
          break;
        default:
          break;
      }
    }
  };
};

export const postAddPortalUpdate: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    PostAddPortalUpdateDispatchTypes
  >
> = (payload: PortalUpdateData) => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: AddPortalUpdateActionDispatchTypes.POST_ADD_PORTAL_UPDATE_INVOKE,
    });
    const response = await PostAddPortalUpdate(configUrl, payload);
    if (response && response.status) {
      switch (response.status) {
        case 422:
        case 400:
        case 500:
        case 404:
          dispatch({
            error: response,
            type: AddPortalUpdateActionDispatchTypes.POST_ADD_PORTAL_UPDATE_ERROR,
          });
          break;
        case 200:
        case 201:
          dispatch({
            response: response.data,
            type: AddPortalUpdateActionDispatchTypes.POST_ADD_PORTAL_UPDATE_SUCCESS,
          });
          toastType.success(ResponseMessages(MessageType.SAVE_PORTAL_UPDATE));
          break;
        default:
          break;
      }
    }
  };
};

export const getPortalUpdate: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    GetPortalUpdateDispatchTypes
  >
> = () => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: GetPortalUpdateActionDispatchTypes.GET_PORTAL_UPDATE_INVOKE,
    });
    const response = await GetPortalUpdate(configUrl);
    if (response && response.data) {
      dispatch({
        response: response.data,
        type: GetPortalUpdateActionDispatchTypes.GET_PORTAL_UPDATE_SUCCESS,
      });
    } else {
      dispatch({
        response: null,
        type: GetPortalUpdateActionDispatchTypes.GET_PORTAL_UPDATE_SUCCESS,
      });
    }
  };
};

export const postAccessAdminList: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    AccessAdminActionTypes
  >
> = (payload: AdminAccessListPayload) => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: UserListActionDispatchTypes.USER_DETAILS_INVOKE,
    });
    const response = await PostAccessAdminList(configUrl, payload);
    if (response && response.status) {
      switch (response.status) {
        case 422:
        case 400:
        case 500:
        case 404:
          dispatch({
            error: response.data,
            response: null,
            type: AccessAdminListActionDispatchTypes.ACCESS_ADMIN_ERROR,
          });
          break;
        case 200:
        case 201:
          dispatch({
            response: response.data,
            type: AccessAdminListActionDispatchTypes.ACCESS_ADMIN_SUCCESS,
          });
          break;
        default:
          break;
      }
    }
  };
  };

export const putAgencyAccessList: ActionCreator<
ThunkAction<
  void,
  ApplicationState,
  Record<string, never>,
  UpdateAgencyAccessActionTypes
>
> = (payload: UpdateAgencyAccessPayload) => {
return async (dispatch: Dispatch) => {
  dispatch({
    type: UpdateAgencyAccessListActionDispatchTypes.UPDATE_AGENCY_ACCESS_INVOKE,
  });
  const response = await PutAgencyAccessList(configUrl, payload);
  if (response && response.status) {
    switch (response.status) {
      case 422:
      case 400:
      case 500:
      case 404:
        dispatch({
          error: response.data,
          response: null,
          type: UpdateAgencyAccessListActionDispatchTypes.UPDATE_AGENCY_ACCESS_ERROR,
        });
        break;
      case 200:
      case 201:
        toastType.success(ResponseMessages(MessageType.AGENCY_UPDATE_SUCCESS))
        dispatch({
          response: response.data,
          type: UpdateAgencyAccessListActionDispatchTypes.UPDATE_AGENCY_ACCESS_SUCCESS,
        });
        break;
      default:
        break;
    }
  }
};
};


export const postAdminUserList: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    UserDetailsActionTypes
  >
> = (payload: UserListPayload) => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: UserListActionDispatchTypes.USER_DETAILS_INVOKE,
    });
    const response = await PostAdminUserList(configUrl, payload);
    if (response && response.status) {
      switch (response.status) {
        case 422:
        case 400:
        case 500:
        case 404:
          dispatch({
            error: response.data,
            response: {
              searchResponse: [{
                "userId": "0",
                "firstName": "",
                "lastName": "",
                "email": "",
                "status": "",
                "approve": "",
                "roleType": ""
              }],
              totalRows: 1
            },
            type: UserListActionDispatchTypes.USER_DETAILS_ERROR,
          });
          break;
        case 200:
        case 201:
          dispatch({
            response: response.data,
            type: UserListActionDispatchTypes.USER_DETAILS_SUCCESS,
          });
          break;
        default:
          break;
      }
    }
  };
};


export const getAdminSelectedUserByEmail: ActionCreator<
  ThunkAction<void, any, Record<string, never>, UserDetailsInAdminActionTypes>
> = (userEmail: string) => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: UserDetailsInAdminActionDispatchTypes.USER_DEATILS_IN_ADMIN_LOADING,
    });
    const payload = { emailId: userEmail };
    const response = await GetAdminSelectedUserByEmail(configUrl, payload);
    if (response && response.status) {
      switch (response.status) {
        case 422:
        case 400:
        case 500:
        case 404:
          toastType.error("Something went wrong user not found !");
          break;
        case 200:
        case 201:
          dispatch({
            response: response.data,
            type: UserDetailsInAdminActionDispatchTypes.USER_DEATILS_IN_ADMIN_SUCCESS,
          });
          break;
        default:
          break;
      }
    }
  };
  };

export const postNotification: ActionCreator<
  ThunkAction<void, ApplicationState, Record<string, never>, NotificationActionTypes>
> = (payload: FormData) => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: NotificationActionDispatchTypes.POST_NOTIFICATION_INVOKE,
    });
    const response = await PostNotification(configUrl, payload);
    if (response && response.status) {
      switch (response.status) {
        case 422:
        case 400:
        case 500:
        case 404:
          dispatch({
            error: response.data,
            response: null,
            type: NotificationActionDispatchTypes.POST_NOTIFICATION_ERROR,
          });
          break;
        case 200:
        case 201:
          toastType.success(ResponseMessages(MessageType.NOTIFICATION_UPLOADED_SUCCESSFULLY))
          dispatch({
            response: response.data,
            type: NotificationActionDispatchTypes.POST_NOTIFICATION_SUCCESS,
          });
          break;
        default:
          break;
      }
    }
  };
};


export const postNotificationList: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    NotificationListDispatchTypes
  >
> = (payload: any) => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: NotificationListActionDispatchTypes.NOTIFICATION_LIST_INVOKE,
    });

    const response = await PostNotificationList(
      configUrl,
      payload
    );
     if (response && response.status) {
      switch (response.status) {
        case 422:
        case 400:
        case 404:
        case 500:
          dispatch({
            type: NotificationListActionDispatchTypes.NOTIFICATION_LIST_ERROR,
          });
          break;
        case 200:
          dispatch({
            response: response.data,
            type: NotificationListActionDispatchTypes.NOTIFICATION_LIST_SUCCESS,
          });
          break;
        default:
          break;
      }
    }
  };
  };

  export const updateNotification: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    NotificationUpdateDispatchTypes
  >
> = (payload: any) => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: NotificationUpdateActionDispatchTypes.NOTIFICATION_UPDATE_INVOKE,
    });

    const response = await PutNotificationUpdate(
      configUrl,
      payload
    );
     if (response && response.status) {
      switch (response.status) {
        case 422:
        case 400:
        case 404:
        case 500:
          dispatch({
            type: NotificationUpdateActionDispatchTypes.NOTIFICATION_UPDATE_ERROR,
          });
          break;
        case 200:
          toastType.success(ResponseMessages(MessageType.NOTIFICATION_UPDATED_SUCCESSFULLY))
          dispatch({
            response: response.data,
            type: NotificationUpdateActionDispatchTypes.NOTIFICATION_UPDATE_SUCCESS,
          });
          break;
        default:
          break;
      }
    }
  };
  };

    export const deactivateNotification: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    NotificationDeactivateDispatchTypes
  >
> = (payload: DeactivateNotificationPayload) => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: NotificationDeactivateActionDispatchTypes.NOTIFICATION_DEACTIVATE_INVOKE,
    });

    const response = await DeactivateNotification(
      configUrl,
      payload
    );
     if (response && response.status) {
      switch (response.status) {
        case 422:
        case 400:
        case 404:
        case 500:
          dispatch({
            type: NotificationDeactivateActionDispatchTypes.NOTIFICATION_DEACTIVATE_ERROR,
          });
          break;
        case 200:
          toastType.success(ResponseMessages(MessageType.DEACTIVATED_SUCCESSFULLY))
          dispatch({
            response: response.data,
            type: NotificationDeactivateActionDispatchTypes.NOTIFICATION_DEACTIVATE_SUCCESS,
          });
          break;
        default:
          break;
      }
    }
  };
  };